// Длительность матча для фильтра, в секундах: `[от, до)`.
export const DURATION_BUCKETS = {
  short: [0, 30 * 60],
  mid: [30 * 60, 40 * 60],
  long: [40 * 60, Number.POSITIVE_INFINITY],
} as const satisfies Record<string, readonly [number, number]>;

export type DurationBucket = keyof typeof DURATION_BUCKETS;
